import { apiService } from './api'
import { LoginRequest, LoginResponse, Admin } from '@/types/api'
import { useTranslation } from 'react-i18next'

export class AuthService {
  // Login
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const client = apiService.getClient()

    const doRequest = async () => {
      // 직접 axios를 사용해서 raw response를 받습니다
      const axiosResponse = await client.post<LoginResponse>('/api/v1/admin/auth/login', credentials)
      const loginResponse = axiosResponse.data

      console.log('Raw login response:', loginResponse)

      if (loginResponse.access_token) {
        // Store tokens
        apiService.setAuthTokens(
          loginResponse.access_token,
          loginResponse.refresh_token
        )
      }

      return loginResponse
    }

    try {
      return await doRequest()
    } catch (error: any) {
      const status = error?.response?.status
      const isNetworkError = !error?.response

      // 로그인 시도에서만: 네트워크/503 계열이면 한 번 더 재시도하여
      // "새로고침해야만 된다"는 느낌을 줄인다.
      if ((isNetworkError || status === 503) && !error?._loginRetry) {
        error._loginRetry = true
        await new Promise((resolve) => setTimeout(resolve, 300))
        return await doRequest()
      }

      throw error
    }
  }

  // Get current admin info
  async getCurrentAdmin(): Promise<Admin> {
    const response = await apiService.get<Admin>('/api/v1/admin/auth/me')
    return response.data!
  }

  // Logout
  async logout(): Promise<void> {
    try {
      await apiService.post('/api/v1/admin/auth/logout')
    } finally {
      // Always clear tokens even if API call fails
      apiService.clearAuthTokens()
    }
  }

  // Check if authenticated
  isAuthenticated(): boolean {
    return apiService.isAuthenticated()
  }

  // Refresh token (if needed)
  async refreshToken(): Promise<LoginResponse> {
    const refreshToken = localStorage.getItem('admin_refresh_token')
    if (!refreshToken) {
      throw new Error('No refresh token available')
    }

    // 관리자도 공통 리프레시 엔드포인트 사용
    const response = await apiService.post<LoginResponse>('/api/v1/auth/refresh', {
      refresh_token: refreshToken
    })

    if (response.data) {
      apiService.setAuthTokens(
        response.data.access_token,
        response.data.refresh_token
      )
    }

    return response.data!
  }
}

export const authService = new AuthService()